import {createAction, props} from '@ngrx/store';
import {RecurringReport} from '../../../reports/models/recurring-report';
import { ReportHistory } from '../../../reports/models/report-history';
import { ReportHistoryMetadata } from '../../../reports/models/report-history-metadata';


export const getRecurringReports = createAction(
  '[Report] Get Recurring Reports',
);

export const getRecurringReportsSuccess = createAction(
  '[Report/API] Get Recurring Reports Success',
  props<{recurringReports: RecurringReport[]}>()
);

export const getRecurringReportsFailure = createAction(
  '[Report/API] Get Recurring Reports Failure',
  props<{error: any}>()
);

export const createRecurringReport = createAction(
  '[Report] Create Recurring Reports',
  props<{recurringReport: RecurringReport}>()
);

export const createRecurringReportSuccess = createAction(
  '[Report/API] Create Recurring Report Success',
  props<{recurringReport: RecurringReport}>()
);

export const createRecurringReportFailure = createAction(
  '[Report/API] Create Recurring Report Failure',
  props<{error: any}>()
);

export const deleteRecurringReport = createAction(
  '[Report] Delete Recurring Report',
  props<{id: number}>()
);

export const deleteRecurringReportSuccess = createAction(
  '[Report/API] Delete Recurring Report Success',
  props<{id: number}>()
);

export const deleteRecurringReportFailure = createAction(
  '[Report/API] Delete Recurring Report Failure',
  props<{error: any}>()
);

export const editRecurringReport = createAction(
  '[Report] Edit Recurring Report',
  props<{recurringReport: RecurringReport, oldId: number}>()
);

export const editRecurringReportSuccess = createAction(
  '[Report/API] Edit Recurring Report Success',
  props<{recurringReport: RecurringReport, oldId: number}>()
);

export const editRecurringReportFailure = createAction(
  '[Report/API] Edit Recurring Report Failure',
  props<{error: any}>()
);

export const getReportFileTypes = createAction(
  '[Report] Get Report File Types',
  props<{reportGeneratorIds: string[], renew?: boolean}>()
);

export const clearReportFileTypes = createAction(
  '[Report] Clear Report File Types'
);

export const getReportFileTypesSuccess = createAction(
  '[Report] Get Report File Types Success',
  props<{reportsFileTypes: any[]}>()
);


export const getReportFileTypesFailure = createAction(
  '[Report] Get Report File Types Failure',
  props<{error: any}>()
);

export const schedule = createAction(
  '[Report] Schedule',
  props<{reportParams: any}>()
);

export const scheduleSuccess = createAction(
  '[Report] Schedule Success',
  props<{reportParams: any}>()
);


export const scheduleFailure = createAction(
  '[Report] Schedule Failure',
  props<{error: any}>()
);


export const getReportsHistory = createAction(
  '[Report] Get Reports History',
  props<{params: any}>()
);

export const getReportsHistorySuccess = createAction(
  '[Report/API] Get Reports History Success',
  props<{reports: ReportHistoryMetadata[]}>()
);

export const getReportsHistoryFailure = createAction(
  '[Report/API] Get Reports History Failure',
  props<{error: any}>()
);

export type ReportActionsUnion = ReturnType<
  typeof getRecurringReports |
  typeof getRecurringReportsSuccess |
  typeof getRecurringReportsFailure |
  typeof createRecurringReport |
  typeof createRecurringReportSuccess |
  typeof createRecurringReportFailure |
  typeof deleteRecurringReport |
  typeof deleteRecurringReportSuccess |
  typeof deleteRecurringReportFailure |
  typeof editRecurringReport |
  typeof editRecurringReportSuccess |
  typeof editRecurringReportFailure |
  typeof getReportFileTypes |
  typeof getReportFileTypesSuccess |
  typeof getReportFileTypesFailure |
  typeof clearReportFileTypes |
  typeof schedule |
  typeof scheduleSuccess |
  typeof scheduleFailure |
  typeof getReportsHistory |
  typeof getReportsHistorySuccess |
  typeof getReportsHistoryFailure
  >;

